<template>
	<autocomplete :id="id" :url="config.services.companyHouse" anchor="title" :min="3" :placeholder="placeholder" :title="title" :on-select="getData"></autocomplete>
</template>

<script>
	import Autocomplete from '../components/Autocomplete.vue';

	export default {
		props: ['placeholder', 'title', 'id'],
		data: function() {
			return {
			}
		},
		components: {
			'autocomplete': Autocomplete
		},
		methods: {
			getData: function(obj) {
				this.$emit('changed', obj);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/CompaniesHouseInput.vue